(function() {
    'use strict';
    angular
        .module('getwellApp')
        .factory('PracticeProfile', PracticeProfile);

    PracticeProfile.$inject = ['$resource'];

    function PracticeProfile ($resource) {
        var resourceUrl =  'api/practice-profiles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
